import { useTranslation } from "react-i18next";
import { ErrorResponse, useRouteError } from "react-router-dom";

const EmbedErrorPage = () => {
  const error = useRouteError();
  const { t } = useTranslation(["common"]);

  const notEmbed = (error as Error).message.includes("iframe");

  return (
    <div className="app-layout">
      <div className="layout_content">
        <div className="page-content container">
          {notEmbed ? (
            <div>
              <h1 className="page_title">
                {t("common:error.global.TITLE", { statusCode: "" })}
              </h1>
              <p>{t("common:error.global.ONLY_IFRAME")}</p>
            </div>
          ) : (
            <div>
              <h1 className="page_title">
                {t("common:error.global.TITLE", {
                  statusCode: (error as ErrorResponse).status,
                })}
              </h1>
              <p>{t("common:error.global.MESSAGE")}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EmbedErrorPage;
